import styles from "@styles/home/heroBanner.module.scss";

const generateNewBannerHtml = () => `
  <section class="${styles.betterthatBanner}">
    <div class="${styles.bannerContent}">
      <div class="${styles.contentWrapper}">
        <div class="${styles.textContent}">
          <h3><strong>About Auckland Westpac Rescue Helicopter</strong></h3>
          <p> For over 50 years, the life-saving Auckland Westpac Rescue Helicopter service has assisted the Greater Auckland, outer islands and Coromandel communities.</p>
          <p>As one of New Zealand’s most trusted charities and an essential medical service, we are reliant on the community’s goodwill and support to help keep us operational 24 hours of the day, 365 days of the year. Through this care, we can assist patients and their loved ones in their greatest time of need.</p>
<!--           <a class="${styles.customBatn}" href="/products">Shop Now</a>-->
        </div>

        <div class="${styles.imageContent}">
          <img src="/assets/home/618d81d2779ccc36b20b7ca3_About.jpg" alt="Betterthat illustration" />
        </div>
      </div>
    </div>
  </section>
        <div class="heading-section lulaBg text-center" >
        Shop Now
        </div>
`;
export const replaceBanner = (data) => {
  if (!data || !data.raw_data) {
    return data;
  }

  try {
    const rawData = JSON.parse(data.raw_data);
    if (Array.isArray(rawData.blocks)) {
      const newBannerHtml = generateNewBannerHtml();

      rawData.blocks = rawData.blocks.map((block) => {
        if (
          block.includes('class="shop-now-block"') &&
          block.includes('data-block-type="home_new"') &&
          block.includes('data-id="1"')
        ) {
          return newBannerHtml;
        }

        if (block.includes('class="proud_title"')) {
          return block.replace(/Better That/g, "Auckland Rescue");
        }
        return block;
      });

      return {
        ...data,
        raw_data: JSON.stringify(rawData),
      };
    }
  } catch (error) {
    console.error("Error parsing or modifying raw_data:", error);
  }

  return data;
};
